import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="absolute top-0 w-full p-4 flex justify-between items-center text-white z-20 bg-black bg-opacity-25">
      
      <div className="hidden md:block w-40"></div>
      
      {/* Logo */}
      <Link to="/" className="text-3xl ml-4 font-serif font-thin tracking-wider opacity-80">
        Atelier Jenny
      </Link>

      {/* Desktop Menu */}
      <nav className="hidden md:flex text-base font-semibold space-x-8">
        <Link to="/nifika" className="hover:underline">ΝΥΦΙΚΑ</Link>
        <a href="#" className="hover:underline">ΒΡΑΔΙΝΑ</a>
        <Link to="/corsets" className="hover:underline">CORSETS</Link>
        {/* <a href="#" className="hover:underline">ΕΠΙΚΟΙΝΩΝΙΑ</a> */}
      </nav>

      {/* Hamburger Menu Icon */}
      <button
        className="md:hidden text-white focus:outline-none"
        onClick={() => setIsMenuOpen(!isMenuOpen)}
      >
        {/* Hamburger Icon */}
        <svg
          className="w-8 h-8"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d={isMenuOpen ? 'M6 18L18 6M6 6l12 12' : 'M4 6h16M4 12h16m-7 6h7'}
          />
        </svg>
      </button>

      {/* Mobile Menu */}
      <div
        className={`absolute top-0 left-0 w-full h-screen bg-black bg-opacity-90 flex flex-col items-center justify-center space-y-8 text-lg font-semibold transition-transform duration-300 ${
          isMenuOpen ? 'translate-x-0' : '-translate-x-full'
        }`}
      >
          <Link to="/" className="hover:underline text-white" onClick={() => setIsMenuOpen(false)}>
          ΑΡΧΙΚΗ
        </Link>
        <Link to="/nifika" className="hover:underline text-white" onClick={() => setIsMenuOpen(false)}>
          ΝΥΦΙΚΑ
        </Link>
        <a href="#" className="hover:underline text-white" onClick={() => setIsMenuOpen(false)}>
          ΒΡΑΔΙΝΑ
        </a>
        <Link to="/corsets" className="hover:underline text-white" onClick={() => setIsMenuOpen(false)}>
          CORSETS
        </Link>
        {/* <a href="#" className="hover:underline text-white" onClick={() => setIsMenuOpen(false)}>
          ΕΠΙΚΟΙΝΩΝΙΑ
        </a> */}
      </div>
    </header>
  );
};

export default Header;
